import React from 'react';
import { motion } from 'framer-motion';
export function ComoFuncionaSection() {
  const steps = [{
    number: '01',
    title: 'Ordenás tu servicio',
    description: 'Definís tu oferta, tu cliente ideal y tu proceso para dejar de vender barato.'
  }, {
    number: '02',
    title: 'Aplicás el sistema que entrenamos con nuestro método VSPP',
    description: 'Seguís un plan claro semana a semana para atraer a las personas correctas.'
  }, {
    number: '03',
    title: 'Generás ingresos constantes',
    description: 'Dejás de improvisar y empezás a escalar de forma predecible y sostenible.'
  }];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-brand-black text-white overflow-hidden" data-id="element-18">
      <div className="max-w-5xl mx-auto" data-id="element-19">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.3
      }} className="text-center mb-20" data-id="element-20">
          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-6" data-id="element-21">
            ¿Cómo funciona?
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-22">
            Un camino paso a paso, sin desvíos ni distracciones.
          </p>
        </motion.div>

        <div className="relative mb-20" data-id="element-23">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-white/10 z-0" data-id="element-24"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative z-10" data-id="element-25">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.25,
            delay: index * 0.1
          }} className="flex flex-col items-center text-center" data-id="element-26">
                <div className="w-24 h-24 rounded-full bg-brand-black border-4 border-brand-orange flex items-center justify-center text-3xl font-heading font-bold text-brand-orange mb-8 shadow-[0_0_30px_rgba(245,158,11,0.2)]" data-id="element-27">
                  {step.number}
                </div>
                <h3 className="text-2xl font-heading font-bold mb-4" data-id="element-28">
                  {step.title}
                </h3>
                <p className="text-gray-400 text-lg" data-id="element-29">{step.description}</p>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        delay: 0.2
      }} className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-30">
          <a href="#" className="w-full sm:w-auto bg-brand-orange text-brand-black font-bold text-lg px-10 py-4 rounded-xl shadow-lg hover:scale-[1.03] transition-transform text-center" data-id="element-31">
            Empezar ahora
          </a>
          <a href="https://wa.me/5491100000000" className="w-full sm:w-auto text-white font-medium hover:text-brand-orange transition-colors text-center underline underline-offset-4" data-id="element-32">
            Hablar por WhatsApp
          </a>
        </motion.div>
      </div>
    </section>;
}